//#region src/core/i18n/locales/de.ts
var de_default = {
	buttons: {
		play: "Wiedergabe",
		pause: "Pause",
		replay: "Erneut abspielen",
		mute: "Stumm schalten",
		unmute: "Ton einschalten"
	},
	seek: {
		forward: "{seconds} Sekunden vorwärts",
		backward: "{seconds} Sekunden zurück"
	},
	fullscreen: {
		enter: "Vollbild",
		exit: "Vollbild beenden"
	},
	captions: {
		enable: "Untertitel einschalten",
		disable: "Untertitel ausschalten"
	},
	pip: {
		enter: "Bild-im-Bild-Modus",
		exit: "Bild-im-Bild-Modus beenden"
	},
	live: {
		playing: "Wird live wiedergegeben",
		seekToEdge: "Zum Live-Rand springen",
		badge: "Live"
	},
	cast: {
		start: "Übertragung starten",
		stop: "Übertragung beenden",
		connecting: "Verbinden"
	},
	airplay: {
		start: "AirPlay starten",
		stop: "AirPlay stoppen"
	},
	slider: { seek: "Spule" },
	time: {
		current: "Aktueller Zeitpunkt",
		duration: "Dauer",
		remaining: "Verbleibende Zeit",
		elapsedSuffix: "{duration} verstrichene Zeit",
		durationSuffix: "{duration} Dauer",
		remainingSuffix: "Noch {duration}",
		showElapsed: "Verstrichene Zeit anzeigen, {duration}.",
		showDuration: "Dauer anzeigen, {duration}.",
		showRemaining: "Verbleibende Zeit anzeigen, {duration}.",
		toggleElapsed: "Zwischen verstrichener und verbleibender Zeit wechseln.",
		toggleDuration: "Zwischen Dauer und verbleibender Zeit wechseln.",
		position: "{current} von {duration}",
		unknown: "Medien nicht geladen, unbekannte Zeit."
	},
	playback: { rate: "Wiedergabegeschwindigkeit {rate}" },
	volume: {
		mutedValue: "{percent}, stummgeschaltet",
		muted: "Stummgeschaltet",
		label: "Lautstärke",
		value: "Lautstärke {value}"
	},
	status: {
		captionsOn: "Untertitel ein",
		captionsOff: "Untertitel aus",
		paused: "Pausiert",
		playing: "Wird wiedergegeben",
		fullscreen: "Vollbild",
		pip: "Bild-in-Bild",
		exitPip: "Bild-in-Bild beenden",
		seekedTo: "Zu {time} gesprungen"
	},
	container: { label: "Mediaplayer" },
	errors: {
		aborted: "Sie haben die Videowiedergabe abgebrochen.",
		network: "Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.",
		decode: "Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.",
		source: "Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.",
		encrypted: "Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",
		unplayable: "Dieses Medium wird vom Player nicht unterstützt.",
		title: "Etwas ist schiefgelaufen.",
		unexpected: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
	},
	common: {
		empty: "",
		ok: "Schließen"
	},
	menu: {
		settings: "Einstellungen",
		quality: "Qualität",
		audio: "Ton",
		default: "Standard",
		speed: "Geschwindigkeit",
		captions: "Untertitel",
		playbackRate: "Wiedergabegeschwindigkeit",
		back: "Zurück",
		off: "Aus",
		auto: "Auto",
		autoWithLabel: "Auto ({label})",
		subtitles: "Untertitel"
	}
};
//#endregion
export { de_default as default };

//# sourceMappingURL=de.js.map